<template>

    <div class="plain-text-primary-motion-text-display">
        <span >   {{ motion.content }}   </span>
    </div>

</template>

<script>
export default {
    name: "plain-text-primary-motion-text-display",

    props: ['motion'],

    mixins: [],

    data: function () {
        return {}
    },

    asyncComputed: {},

    computed: {},

    methods: {}

}
</script>

<style scoped>

</style>
